export default __webpack_public_path__ + "static/media/commentBG.a2a01311.jpg";